import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "./../../../../../mst/stores/mk8s.draft";
import { NodePoolLabel } from "./../../../nodePoolLabel";
import { NodePoolTaint } from "./../../../nodePoolTaint";
import { Button as AntButton } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { NGLabel } from "../../../../../newcomponents/text/label";
import { NGButton } from "../../../../../newcomponents/button/Button";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateProviderPaperspaceUnmanagedNodePoolsRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const navigate = useNavigate();
  const p = mk8sDraft.provider_paperspace!;

  return (
    <>
      <NGLabel>Unmanaged Node Pools</NGLabel>
      {p.unmanagedNodePools.length > 0 ? (
        <div
          className="flex items-center table-labels px-2 py-1"
          style={{ borderTopLeftRadius: 6, borderTopRightRadius: 6 }}
        >
          <div className="w-2/12">Name</div>
          <div className="w-4/12">Labels</div>
          <div className="w-4/12">Taints</div>
          <div className="w-2/12"></div>
        </div>
      ) : (
        <div
          className="border py-8 flex flex-col gap-4 mt-4 items-center justify-center"
          style={{ borderRadius: 6, width: 450 }}
        >
          <div className="text-lg">No unmanaged node pools are added.</div>
          <NGButton variant={"action"} onClick={() => navigate("-add")}>
            Add an Unmanaged Node Pool
          </NGButton>
        </div>
      )}
      {p.unmanagedNodePools.length > 0 ? (
        <div className="border border-t-0" style={{ borderBottomRightRadius: 6, borderBottomLeftRadius: 6 }}>
          {p.unmanagedNodePools.map((np, npIndex) => {
            const lastNodePool = npIndex === p.unmanagedNodePools.length - 1;

            return (
              <>
                <div key={np.index} className={`flex p-2 ${lastNodePool ? "" : "border-b"}`}>
                  <div className="w-2/12">
                    <Link to={`${np.index}`}>{np.name.value}</Link>
                  </div>
                  <div className="w-4/12">
                    {np.labels.items.map((l) => (
                      <NodePoolLabel label={{ key: l.firstValue, value: l.secondValue }} />
                    ))}
                  </div>
                  <div className="w-4/12">
                    {np.taints.items.map((l) => (
                      <NodePoolTaint taint={{ key: l.firstValue, value: l.secondValue, effect: l.thirdValue }} />
                    ))}
                  </div>
                  <div className="w-2/12 flex items-center justify-end gap-2">
                    <AntButton
                      size={"small"}
                      type={"primary"}
                      danger
                      onClick={() => p.removeUnmanagedNodePoolAt(np.index)}
                    >
                      Remove
                    </AntButton>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export const Mk8sCreateProviderPaperspaceUnmanagedNodePools = observer(
  Mk8sCreateProviderPaperspaceUnmanagedNodePoolsRaw,
);
